<!-- 创建时间2024/04/24 09:52:21 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：操作栏 -->
<template>
  <div class="yxtbiz-doc-player__toolbar">
    <div class="yxtbiz-doc-player__toolbar-item"
      :class="{'is-page': item.type === 'page', [item.className]: true, 'is-disabled': item.disabled}" v-for="item in operations"
      :key="item.type" @click="handle(item)">
      <template v-if="item.type === 'page'">
        <div class="yxtbiz-doc-player__toolbar-page">
          <yxt-input v-model="current" size="mini" :disabled="!total" @keydown.enter.native="change(current)"
            @blur="current = page"></yxt-input>
          <span class="mh4">/</span>
          {{ total }}
        </div>
      </template>
      <yxtf-svg v-else :icon-class="item.icon" width="20px" height="20px" />
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'toolbar',
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Number,
      default: 0
    },
    toolbars: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      page: 1,
      current: 1,
      total: 0
    };
  },
  computed: {
    operations() {
      let list = [];
      if (this.toolbars.includes('moon')) {
        list = list.concat([{ type: 'moon', icon: this.dark ? 'f_sun' : 'f_night' }]);
      }
      if (this.toolbars.includes('zoom')) {
        list = list.concat([
          { type: 'zoom+', icon: 'f_zoom-in-2', disabled: this.zoom >= 10 },
          { type: 'zoom-', icon: 'f_zoom-out-2', disabled: this.zoom <= -5 }
        ]);
      }
      if (this.toolbars.includes('fullscreen')) {
        list = list.concat([{ type: 'fullscreen', icon: this.fullscreen ? 'f_fullscreen-exit' : 'f_fullscreen' }]);
      }
      return [
        ...list,
        { type: 'page-', icon: 'f_up-circle-o', className: 'ml40', disabled: this.page <= 1 },
        { type: 'page' },
        { type: 'page+', icon: 'f_down-circle-o', disabled: this.page >= this.total}
      ];
    }
  },
  created() {
    this.$root.$on('PAGES_INIT', this.pagesInit);
    this.$root.$on('PAGE_CHANGE', this.pageChange);
  },
  beforeDestroy() {
    this.$root.$off('PAGES_INIT', this.pagesInit);
    this.$root.$off('PAGE_CHANGE', this.pageChange);
  },
  methods: {
    pagesInit(page) {
      this.total = page;
    },
    pageChange(page) {
      const p = Math.max(page, 1);
      if (p !== this.page) {
        this.page = this.current = p;
        this.$emit('pageChange', p);
      }
    },
    change(page) {
      if (page > this.total) {
        this.current = this.page;
        return;
      }
      if (page !== this.page) {
        this.$emit('scrollToPage', page);
      }
    },
    handle({ type }) {
      if (type === 'page') return;
      if (type === 'moon') {
        this.$emit('update:dark', !this.dark);
      } else if (type === 'fullscreen') {
        this.$emit('toggleFullScreen');
      } else if (type === 'page-' && this.current > 1) {
        this.current--;
        this.change(this.current);
      } else if (type === 'page+' && this.current < this.total) {
        this.current++;
        this.change(this.current);
      } else if (type === 'zoom-' && this.zoom > -5) {
        this.$emit('update:zoom', this.zoom - 1);
      } else if (type === 'zoom+' && this.zoom < 10) {
        this.$emit('update:zoom', this.zoom + 1);
      }
    }
  }
};
</script>